module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/6_4f1c7cfccbfc1ab8f166797c337e2d48.png";